import { MODAL_TYPES } from "../constants";

const { SIDE_RIGHT, CENTER, CENTER_LARGE } = MODAL_TYPES;

export const getClassnamesForModalType = modalType => ({
  center: modalType === CENTER || modalType === CENTER_LARGE,
  large: modalType === CENTER_LARGE,
  side: modalType === SIDE_RIGHT
});
